import React, { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import Header from '../Common_Files/Header';
import Footer from '../Common_Files/Footer';
import config from '../Common_Files/Config';
import 'datatables.net-bs5/css/dataTables.bootstrap5.min.css';
import $ from 'jquery';
import 'datatables.net-bs5';

const StockReport = () => {
  const [searchValue, setSearchValue] = useState('');
  const tableRef = useRef(null);

  const formatOnPo = (onpo) => {
    if (onpo && typeof onpo === 'object' && onpo.totalPO !== undefined) {
      return onpo.totalPO;
    }
    return onpo || 0;
  };

  useEffect(() => {
    const accessToken = localStorage.getItem('accessToken');
    if (!accessToken) {
      window.location.href = '/login';
      return;
    }

    const $table = $(tableRef.current);
    if ($.fn.DataTable.isDataTable($table)) {
      $table.DataTable().destroy();
    }

    const table = $table.DataTable({
      serverSide: true,
      processing: true,
      ajax: async (data, callback) => {
        const formData = new FormData();
        formData.append('draw', data.draw);
        formData.append('start', data.start);
        formData.append('length', data.length);
        formData.append('searchValue', searchValue);
        formData.append('stock_type', 'all');
        formData.append('warehouse_id', 'all');

        try {
          const response = await fetch(`${config.api_url}/get-products-list`, {
            method: 'POST',
            headers: { Authorization: `Bearer ${accessToken}` },
            body: formData,
          });
          const result = await response.json();
          callback({
            draw: result.draw,
            recordsTotal: result.recordsTotal,
            recordsFiltered: result.recordsFiltered,
            data: result.products || [],
          });
        } catch {
          callback({ draw: data.draw, recordsTotal: 0, recordsFiltered: 0, data: [] });
        }
      },
      columns: [
        { data: 'code' },
        { data: 'product_desc' },
        { data: 'pack' },
        { data: 'size' },
        { data: 'supplier_name' },
        { data: 'quantity', className: 'text-end' },
        { data: 'freestock', className: 'text-end' },
        { data: 'onso', className: 'text-end' },
        {
          data: 'onpo',
          className: 'text-end',
          render: (data) => formatOnPo(data),
        },
        { data: 'price', className: 'text-end' },
        { data: 'cost', className: 'text-end' },
        {
          data: 'status',
          render: (data) => (data == 1 || data === '1' ? 'Active' : 'Inactive'),
        },
      ],
      pageLength: 50,
      lengthMenu: [10, 25, 50, 100],
      ordering: false,
    });

    return () => {
      table.destroy();
    };
  }, [searchValue]);

  return (
    <div>
      <Header />
      <div className="breadcrumbs">
        <div className="container-fluid">
          <div className="row">
            <div className="col-12">
              <Link to="/Dashboard"><i className="fa fa-home" /></Link> &gt;
              <Link to="/Dashboard">Dashboard</Link> &gt;
              <span className="last-crumb">Stock Report</span>
            </div>
          </div>
        </div>
      </div>
      <div className="main-container">
        <div className="container-fluid">
          <div className="row">
            <div className="col-12">
              <div className="dashboard">
                <div className="topsearch-area">
                  <div className="row">
                    <div className="col-lg-5 col-md-6">
                      <div className="row mb-2">
                        <label className="col-sm-4 col-form-label">Product Search</label>
                        <div className="col-sm-8">
                          <input
                            type="text"
                            className="search-area form-control"
                            placeholder="Code, name, barcode..."
                            autoComplete="off"
                            value={searchValue}
                            onChange={(e) => setSearchValue(e.target.value)}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="vertical-scrl-wrapper common-table" id="style-3">
                  <table className="table table-bordered dataTable" id="stockReportTable" ref={tableRef}>
                    <thead>
                      <tr>
                        <th>Code</th>
                        <th>Product</th>
                        <th>Pack</th>
                        <th>Size</th>
                        <th>Supplier</th>
                        <th>Stock</th>
                        <th>Free Stock</th>
                        <th>On SO</th>
                        <th>On PO</th>
                        <th>Sell Price</th>
                        <th>Cost</th>
                        <th>Status</th>
                      </tr>
                    </thead>
                    <tbody />
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default StockReport;
